import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'catalogos/codigos-postales-administrador/';

/**
 * GET CodigoPostals
 * param {object} params
 * @returns {Promise<object>}
 */
export const getCodigosPostales = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET CodigoPostal
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getCodigoPostal = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST CodigoPostal
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCodigoPostal = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH CodigoPostal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCodigoPostal = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE CodigoPostal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteCodigoPostal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
